import React from 'react';
import { cn } from '@utils/cn';
import { ReactComponent as LoaderIcon } from '@assets/icons/loader.svg';

type LoadingSize = 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';

interface LoadingProps {
  center?: boolean;
  fadeUp?: boolean;
  size?: LoadingSize;
  className?: string;
}

export const Loading: React.FC<LoadingProps> = ({
  size = 'md',
  className,
  center = false,
  fadeUp = false,
}) => {
  const sizeClasses: Record<LoadingSize, string> = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8',
    '2xl': 'w-10 h-10',
    '3xl': 'w-12 h-12',
  };

  return (
    <div
      className={cn(
        center && 'flex items-center justify-center h-screen w-full',
        fadeUp && 'animate-fade-up',
        className,
      )}>
      <LoaderIcon
        className={cn(
          'animate-spin text-current',
          sizeClasses[size],
          className,
        )}
      />
    </div>
  );
};
